import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';

// set uuid as constant (otherwise multiple sessionIds will be generated)
const constantUuid = uuid();

export function useSessionId() {
  return useMemo(() => constantUuid, []);
}
